import type {
    CustomerContactPayload,
    CustomerContactResponse,
} from '@/types/apps/customer-contact.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Creatable } from '@/types/service/creatable.interface';
import type { Deletable } from '@/types/service/deletable.interface';
import type { Indexable } from '@/types/service/indexable.interface';
import type { Showable } from '@/types/service/showable.interface';
import type { Updatable } from '@/types/service/updatable.interface';

type CustomerListResponse = ApiResponse<
    PaginatedResult<CustomerContactResponse>
>;

export class CustomerContactService
    implements Showable, Updatable, Deletable, Creatable, Indexable
{
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        customer: {
            base: () => '/api/customer-contacts',
            detail: (id: string) => `/api/customer-contacts/${id}`,
        },
    };

    public index(params?: QueryParams): Promise<CustomerListResponse> {
        return this.apiClient.fetchApi(this.endpoints.customer.base(), params);
    }

    public detail(
        id: string,
        params?: QueryParams
    ): Promise<ApiResponse<CustomerContactResponse>> {
        // URL đã bao gồm id
        const url = this.endpoints.customer.detail(id);

        return this.apiClient.fetchApi<CustomerContactResponse>(url, params);
    }

    public create(
        params: CustomerContactPayload
    ): Promise<ApiResponse<CustomerContactResponse>> {
        return this.apiClient.postApi(this.endpoints.customer.base(), params);
    }

    public update(
        id: string,
        payload: CustomerContactPayload
    ): Promise<ApiResponse<CustomerContactResponse>> {
        const url = this.endpoints.customer.detail(id);

        return this.apiClient.putApi(url, payload);
    }

    public destroy(
        ids: string[],
        isHardDeleted: boolean = false
    ): Promise<ApiResponse<void>> {
        const url = this.endpoints.customer.base();

        return this.apiClient.destroyApi<void>(url, ids, isHardDeleted);
    }
}
